import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { instanceOfFilterRange } from "../instanceOf/instanceOfFilterRange.js";
const prepareFilterItemValue = ({
  type,
  filterChoiceValue,
  filterValues
}) => {
  switch (type) {
    case ConstructorWidgetEnum.FilterSlider: {
      if (instanceOfFilterRange(filterValues)) {
        return filterChoiceValue ?? filterValues.value[1];
      }
      return filterChoiceValue;
    }
    case ConstructorWidgetEnum.FilterRangeSlider: {
      if (instanceOfFilterRange(filterValues)) {
        return filterChoiceValue ?? filterValues.value;
      }
      return filterChoiceValue;
    }
    default:
      return filterChoiceValue;
  }
};
export {
  prepareFilterItemValue
};
